import { Shape } from "three";
import { cache } from "../../cache";
export const createRoundedRectangularShape = (left, bottom, width, height, cornerRadius) => {
    return cache(() => {
        const shape = new Shape();
        shape.absarc(left + cornerRadius.bottomLeft, bottom + cornerRadius.bottomLeft, cornerRadius.bottomLeft, -Math.PI / 2, -Math.PI, true);
        shape.absarc(left + cornerRadius.topLeft, bottom + height - cornerRadius.topLeft, cornerRadius.topLeft, Math.PI, Math.PI / 2, true);
        shape.absarc(left + width - cornerRadius.topRight, bottom + height - cornerRadius.topRight, cornerRadius.topRight, Math.PI / 2, 0, true);
        shape.absarc(left + width - cornerRadius.bottomRight, bottom + cornerRadius.bottomRight, cornerRadius.bottomRight, 0, -Math.PI / 2, true);
        shape.autoClose = true;
        return shape;
    }, "createRoundedRectangularShape", [left, bottom, width, height, cornerRadius]);
};
//# sourceMappingURL=createRoundedRectangularShape.js.map